import React from "react";
import { Container, Color, Label } from "./Styled";
import { Entity } from "../../../../../../model/intent/types";

type ItemProps = {
  entity: Entity;
  onSelect: (entity: Entity) => void;
};

const Item: React.FunctionComponent<ItemProps> = props => {
  const { onSelect, entity } = props;
  return (
    <Container onClick={() => onSelect(entity)}>
      <Color color={entity.color} />
      <Label>{entity.title}</Label>
    </Container>
  );
};

export default Item;
